import { ErrorMessage } from "@msys/ui";
import { Button } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { useSapS4HanaIntegrationSettingsState } from "../sap-s4-hana/hooks.js";
import { isRichterFrenzelSapIntegration } from "../sap-s4-hana/richter-frenzel/isRichterFrenzelSapIntegration.js";

type SettingsState = ReturnType<typeof useSapS4HanaIntegrationSettingsState>;

export function QuoteItemAttachmentControls({
  canBeEdited,
  hasSapS4HanaIntegration,
  settingsState,
  genericBox,
  rfBox,
}: {
  canBeEdited: boolean;
  hasSapS4HanaIntegration: boolean;
  settingsState: SettingsState;
  genericBox: React.ReactNode;
  rfBox: React.ReactNode;
}) {
  const { t } = useTranslate("Global");
  if (!canBeEdited) return null;

  if (!hasSapS4HanaIntegration || settingsState.status === "disabled") {
    return <>{genericBox}</>;
  }
  if (settingsState.status === "loading") return null;
  if (settingsState.status === "error") {
    return (
      <ErrorMessage
        message={settingsState.error.message}
        button={
          <Button onClick={() => void settingsState.retry()} variant="outlined">
            {t("Retry")}
          </Button>
        }
      />
    );
  }

  return isRichterFrenzelSapIntegration(settingsState.settings) ? (
    <>{rfBox}</>
  ) : (
    <>{genericBox}</>
  );
}
